import { GetStaticProps } from 'next'

import { formatSitemapData } from '@/helpers/formatSitemapData'
import { PageProps } from '@/templates/types'
import axios from 'axios'
import { serverLogger } from 'lib/Logger/serverLogs'
import { getSettingsMarkdowns } from 'lib/content'
import xml2js, { Parser } from 'xml2js'

import { MetaTags } from '@/components/MetaTags'
import { Navbar, NavbarAdminOptions } from '@/components/Navigation/Navbar'
import Sitemap, { SitemapData } from '@/components/Sitemap/Sitemap'
import Footer from '@/components/global/Footer/Footer'

interface UrlObject {
  loc: string[]
}

interface SitemapResult {
  urlset: {
    url: UrlObject[]
  }
}

interface SitemapProps {
  sitemapData: Array<SitemapData>
  settings: PageProps['settings']
}

const pageMetadata = {
  metaPageDescription: 'Ethos Site map',
  metaPageTitle: 'Ethos Life',
  pageMetaRobots: 'crawl',
  pageSocialImage:
    'https://res.cloudinary.com/getethos/image/upload/v1565712064/01_NEW%20Lifestyle%20%28Rebrand%29/life-insurance-father-and-son-playing.jpg',
}

const SitemapPage = (props: SitemapProps) => {
  return (
    <>
      <MetaTags
        pageContent={{
          pageMetadata,
        }}
        settings={props.settings}
      />
      <Navbar
        agentLayout={false}
        noNavbar={false}
        navbarLogoOnly={false}
        animatedNavbar={NavbarAdminOptions.Full}
        hideDesktopCta={false}
        partnerLogo={null}
        partnerLogoMobile={null}
        partnerLogoSeparator={'plus'}
        settings={props.settings}
      />
      <Sitemap data={props.sitemapData} />
      <Footer settings={props.settings} agentLayout={false} />
    </>
  )
}

export const getStaticProps: GetStaticProps = async () => {
  let sitemapData: Array<SitemapData> = []
  let settings = {}

  try {
    const response = await axios.get(`https://www.ethoslife.com/sitemap.xml`)
    const xml: string = response.data

    const parser: Parser = new xml2js.Parser()
    const result: SitemapResult = await parser.parseStringPromise(xml)

    if (result.urlset && result.urlset.url) {
      const pages = result.urlset.url.map((urlObject) => ({
        loc: urlObject.loc[0],
      }))

      sitemapData = formatSitemapData(pages)
    } else {
      serverLogger.error(
        `[sitemap getServerSideProps] - No URLs found in the sitemap.`
      )
      sitemapData = []
    }
  } catch (error) {
    serverLogger.error(
      `[sitemap getServerSideProps] - Error fetching sitemap: `,
      { error }
    )
    sitemapData = []
  }

  try {
    settings = await getSettingsMarkdowns('settings')
  } catch (error) {
    serverLogger.error(
      `[sitemap getServerSideProps] - Error fetching settings: `,
      { error }
    )
  }

  return {
    props: {
      sitemapData,
      settings,
    },
  }
}

export default SitemapPage
